import React, { forwardRef, useEffect } from 'react'
import PropTypes from 'prop-types'

const FlipMoveTypeName = forwardRef(({ parentRef, children }, ref) => {
	useEffect(() => {
		if (typeof ref === 'function') {
			ref(parentRef?.current)
		}
	}, [ref, parentRef])

	return <>{children}</>
})

FlipMoveTypeName.propTypes = {
	parentRef: PropTypes.object,
	children: PropTypes.node,
}

export default FlipMoveTypeName
